import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'press-line-details',
  templateUrl: './press-line-details.component.html',
  styleUrls: ['./press-line-details.component.scss']
})
export class PressLineDetailsComponent implements OnInit {
  PressId: any;

  @Input()
  show = false;

  @Input()
  set data(dataItem: any) {
    if (dataItem) {
      this.PressId = dataItem.Id;
    }
  }

  @Output()
  close: EventEmitter<any> = new EventEmitter();

  constructor() { }


  ngOnInit() {
  }

  onClose() {
    this.close.emit();
    this.show = false;
  }

}
